if (!customElements.get('cis-editorial-scroll')) {

  class CISEditorialScroll extends HTMLElement {

    connectedCallback() {

      if (this._cisEditorialInitialized) return;

      this._cisEditorialInitialized = true;


      this.panels = Array.from(
        this.querySelectorAll(
          '[data-cis-editorial-panel]'
        )
      );


      this.steps = Array.from(
        this.querySelectorAll(
          '[data-cis-editorial-step]'
        )
      );


      if (
        !this.panels.length ||
        !this.steps.length
      ) {
        return;
      }


      this.currentStep = 0;


      /*
        Sicherstellen, dass Panel 1
        sofort sichtbar ist.
      */

      this.showStep(0);


      /*
        EXAKT dasselbe Prinzip wie beim Hero:

        Ein unsichtbarer echter Scroll-Step
        erreicht die Mitte des Viewports.

        Erst dann wechseln wir den Inhalt.
      */

      this.observer =
        new IntersectionObserver(

          (entries) => {

            entries.forEach((entry) => {

              if (!entry.isIntersecting) {
                return;
              }


              const step =
                Number(
                  entry.target.dataset.cisEditorialStep
                );


              if (Number.isNaN(step)) {
                return;
              }


              this.showStep(step);

            });

          },

          {
            root: null,

            /*
              Sehr schmaler Bereich um die
              Bildschirmmitte.

              Dadurch wird nicht schon beim
              ersten Sichtbarwerden der Section
              weitergeschaltet.
            */

            rootMargin:
              '-46% 0px -46% 0px',

            threshold: 0
          }

        );


      this.steps.forEach((step) => {

        this.observer.observe(step);

      });

    }



    disconnectedCallback() {

      if (this.observer) {

        this.observer.disconnect();

      }


      this._cisEditorialInitialized = false;

    }



    showStep(step) {

      const nextStep =
        Math.max(
          0,
          Math.min(
            step,
            this.panels.length - 1
          )
        );


      if (
        nextStep === this.currentStep &&
        this.panels[nextStep]
          .classList
          .contains('is-active')
      ) {

        return;

      }


      this.currentStep =
        nextStep;


      this.setAttribute(
        'data-step',
        String(nextStep)
      );


      this.panels.forEach(
        (panel, index) => {

          const active =
            index === nextStep;


          panel.classList.toggle(
            'is-active',
            active
          );


          panel.setAttribute(
            'aria-hidden',
            active
              ? 'false'
              : 'true'
          );

        }
      );

    }

  }


  customElements.define(
    'cis-editorial-scroll',
    CISEditorialScroll
  );

}